module.exports = __webpack_public_path__ + "img/gourmet3.5edae47e.jpg";